import { BaseEntity } from '../../../base-entity';

export enum HourChangeRequestStatusType {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
}

export interface CourseHourChangeRequestEntityType extends BaseEntity {
  id: number;
  courseId: number;
  requestedAdditionalHours: number;
  justification: string;
  status: HourChangeRequestStatusType;
  updateStatusById: number;
  updateStatusAt: Date | null;
}

export interface CourseHourChangeRequestWithUsers
  extends CourseHourChangeRequestEntityType {
  creatorId: number;
  creatorFirstName: string;
  creatorLastName: string;
  statusUpdatedById: number | null;
  statusUpdaterFirstName: string | null;
  statusUpdaterLastName: string | null;
}

export interface CourseHourChangeRequestWithDetailsDto
  extends CourseHourChangeRequestEntityType {
  courseName: string;
  courseId: number;
  courseHours: number;
  programId: number;
  branchName: string;
  branchId: number;
}
